import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEventRequest } from "../../../store/social/social.actions";
import {
    getEvents,
    getLiveStream,
} from "../../../store/social/social.selector";
import { getImage } from "../../../store/user/user.selector";
import _ from "underscore";
import moment from "moment";

const ReplayChat = () => {
    const dispatch = useDispatch();
    const { comments, livestream } = useSelector((state) => {
        return {
            comments: getEvents(state),
            livestream: getLiveStream(state),
        };
    });

    useEffect(() => {
        dispatch(fetchEventRequest("?where=livestream:" + livestream._id));
    }, []);

    let filteredComments = _.chain(comments)
        .sortBy((o) => new moment(o.dateCreated))
        .sortBy((o) => o.pinned === "yes")
        .value();

    return (
        <div className="h-[calc(100vh_-_175px)] overflow-y-auto">
            {filteredComments.map((chat) => {
                return (
                    <div
                        key={chat._id}
                        className="py-[3px] pl-1.5 pr-4 flex items-center justify-between rounded-md border border-black-10 mb-2.5 cursor-pointer"
                    >
                        <div className="flex items-center">
                            <img
                                src={getImage(chat.infoUser.attachments)}
                                alt=""
                                className="rounded-full w-[35px] aspect-square mr-2.5"
                            />
                            <div className="">
                                <h4 className="text-sm font-medium text-ebony-color capitalize">
                                    {chat.infoUser.fullName}
                                </h4>
                                <p className="text-[10px] text-black-50">
                                    {chat.content}
                                </p>
                            </div>
                        </div>
                        <div className="">
                            <p className="text-[10px] text-black-50">
                                {moment(chat.dateCreated).fromNow()}
                            </p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ReplayChat;
